import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './modules/reducer';
import multiWithPromiseMiddleware from './middleware/multiWithPromiseMiddleware';

const createStoreWithMiddleware = applyMiddleware(
  multiWithPromiseMiddleware(),
  thunk
)(createStore);

export default function configureStore(initialState) {
  return createStoreWithMiddleware(reducer, initialState)
}


// WEBPACK FOOTER //
// ./src/redux/configureStore.js